module.exports = __webpack_public_path__ + "img/nodeBackgroundDrawOblique.991db8c4.svg";